import React, { useEffect, useMemo, useState } from "react";
import Gallery from "../../../Modulos/Gallery";
import VideoGallery from "../../../componentes/videoGallery";
import EnVivoPanel from "../../enVivo/EnVivoPanel";
import "../../../Pages/Css/multimediaHub.css";

const TABS = {
  PHOTOS: "photos",
  VIDEOS: "videos",
  STREAMING: "streaming",
  ACTIONS: "actions",
};

const TAB_META = {
  [TABS.PHOTOS]: { label: "Fotos", icon: "bx bx-image-alt" },
  [TABS.VIDEOS]: { label: "Videos", icon: "bx bx-video" },
  [TABS.STREAMING]: { label: "Streaming", icon: "bx bx-radio-circle-marked" },
  [TABS.ACTIONS]: { label: "Acciones", icon: "bx bx-rocket" },
};

const ModalMultimediaHub = ({
  contratoData,
  selectedContrato,
  infoContrato,
  initialTab = TABS.PHOTOS,
  onSelectTab,
  onOpenUploadPhoto,
  onOpenUploadVideo,
  onOpenTracking,
  onOpenMonitoreo,
  onOpenConsolidado,
  initialStreamUrl,
  initialStreamVersion,
  liveActive,
  deviceActiveStreamUrls,
  hideStreamControls = false,
  streamingTabLabel = "Streaming",
  showVideos = true,
}) => {
  const [activeTab, setActiveTab] = useState(initialTab);
  const visibleTabs = showVideos
    ? [TABS.PHOTOS, TABS.STREAMING, TABS.VIDEOS, TABS.ACTIONS]
    : [TABS.PHOTOS, TABS.STREAMING, TABS.ACTIONS];

  useEffect(() => {
    setActiveTab(!showVideos && initialTab === TABS.VIDEOS ? TABS.STREAMING : initialTab);
  }, [initialTab, showVideos]);

  const activeContrato = useMemo(
    () => contratoData || { ContractID: selectedContrato || "ND" },
    [contratoData, selectedContrato]
  );

  const setTab = (tab) => {
    setActiveTab(tab);
    onSelectTab?.(tab);
  };

  const resolveTab = (tab) => `mh-tab ${activeTab === tab ? "is-active" : ""}`;
  const getTabLabel = (tabKey) =>
    tabKey === TABS.STREAMING ? streamingTabLabel : TAB_META[tabKey].label;

  return (
    <div className="multimedia-hub">
      <div className="multimedia-hub-header">
        <div>
          <h5 className="multimedia-hub-title">Centro Multimedia + Streaming</h5>
          <p className="multimedia-hub-subtitle">Evidencias visuales, analítica IA y transmisión en vivo en una sola vista.</p>
        </div>
        <span className="multimedia-hub-chip">
          Contrato: {activeContrato?.ContractID || "ND"}
        </span>
      </div>

      <div className="multimedia-hub-tabs">
        {visibleTabs.map((tabKey) => (
          <button
            key={tabKey}
            type="button"
            className={resolveTab(tabKey)}
            onClick={() => setTab(tabKey)}
          >
            <i className={TAB_META[tabKey].icon} aria-hidden="true"></i>
            <span>{getTabLabel(tabKey)}</span>
          </button>
        ))}
      </div>

      <div className="multimedia-hub-links">
        <a href="#" onClick={(e) => { e.preventDefault(); onOpenTracking?.(); }}>Tracking</a>
        {" / "}
        <a href="#" onClick={(e) => { e.preventDefault(); onOpenMonitoreo?.(); }}>Monitoreo</a>
        {" / "}
        <a href="#" onClick={(e) => { e.preventDefault(); onOpenConsolidado?.(); }}>Consolidado</a>
      </div>

      <div className="multimedia-hub-content">
      {activeTab === TABS.PHOTOS && (
        <div id="ModalGaleriaW" className="multimedia-hub-gallery-shell">
          <Gallery
            mostrarFotos
            contrato={selectedContrato}
            infoContrato={infoContrato}
            showQuickLinks={false}
            tracking={onOpenTracking}
            monitoreo={onOpenMonitoreo}
            consolidado={onOpenConsolidado}
          />
        </div>
      )}

      {activeTab === TABS.VIDEOS && <VideoGallery contrato={selectedContrato} />}

      {activeTab === TABS.STREAMING && (
        <EnVivoPanel
          contrato={activeContrato}
          initialStreamUrl={initialStreamUrl}
          initialStreamVersion={initialStreamVersion}
          liveActive={liveActive}
          deviceActiveStreamUrls={deviceActiveStreamUrls}
          hideStreamControls={hideStreamControls}
        />
      )}

      {activeTab === TABS.ACTIONS && (
        <div className="multimedia-hub-actions-grid">
          <div className="multimedia-hub-actions-col">
            <div className="multimedia-hub-actions-card h-100">
              <div className="multimedia-hub-action-icon" aria-hidden="true">
                <i className="bx bx-camera"></i>
              </div>
              <h6 className="mb-2">Subir fotos</h6>
              <p className="mb-3 text-muted">Carga evidencia fotográfica del contrato actual.</p>
              <button type="button" className="mh-tab multimedia-hub-action-btn" onClick={onOpenUploadPhoto}>
                <i className="bx bx-upload" aria-hidden="true"></i>
                <span>Subir fotos</span>
              </button>
            </div>
          </div>
          <div className="multimedia-hub-actions-col">
            <div className="multimedia-hub-actions-card h-100">
              <div className="multimedia-hub-action-icon" aria-hidden="true">
                <i className="bx bx-video"></i>
              </div>
              <h6 className="mb-2">Subir videos</h6>
              <p className="mb-3 text-muted">Carga evidencia en video del contrato actual.</p>
              <button type="button" className="mh-tab multimedia-hub-action-btn" onClick={onOpenUploadVideo}>
                <i className="bx bx-upload" aria-hidden="true"></i>
                <span>Subir videos</span>
              </button>
            </div>
          </div>
        </div>
      )}
      </div>
    </div>
  );
};

export { TABS as multimediaHubTabs };
export default ModalMultimediaHub;


